import Vue from "vue";
import Vuex from "vuex";
import { lock, unlock } from "tua-body-scroll-lock";

Vue.use(Vuex);

const menu = document.querySelector(".menu");

export default new Vuex.Store({
  state: {
    isHomePage: false,
    isMenuActive: false,
  },
  mutations: {
    validHomePage(state) {
      // トップページにアクセスしたときはフラグをtrueにする
      state.isHomePage = true;
    },
    invalidHomePage(state) {
      // トップページ以外へのアクセスはフラグをfalseにする
      state.isHomePage = false;
    },
    toggleMenuState(state) {
      state.isMenuActive = !state.isMenuActive;
      // メニューが開いているときは、bodyにoverflow:hiddenを付与する
      if (state.isMenuActive) {
        lock(menu);
      } else {
        unlock(menu);
      }
    },
    invalidMenuState(state) {
      state.isMenuActive = false;
      // メニューが閉じられているときは、bodyのoverflow:hiddenを必ず削除する
      unlock(menu);
    },
  },
  actions: {},
  modules: {},
});
